import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const PauseSchema = Yup.object().shape({
  name: Yup.string().required("Obrigatório"),
});

const PauseModal = ({ open, onClose, pauseId, onSave }) => {
  const [pause, setPause] = useState({ name: "" });

  useEffect(() => {
    const fetchPause = async () => {
      if (!pauseId) {
        setPause({ name: "" });
        return;
      }
      try {
        const { data } = await api.get(`/pauses`);
        const found = data.find(p => p.id === pauseId);
        if (found) setPause(found);
      } catch (err) {
        toastError(err);
      }
    };
    fetchPause();
  }, [pauseId, open]);

  const handleClose = () => {
    onClose();
    setPause({ name: "" });
  };

  const handleSavePause = async (values) => {
    try {
      if (pauseId) {
        const { data } = await api.put(`/pauses/${pauseId}`, values);
        if(onSave) onSave(data);
        toast.success("Pausa atualizada!");
      } else {
        const { data } = await api.post("/pauses", values);
        if(onSave) onSave(data);
        toast.success("Pausa adicionada!");
      }
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{pauseId ? "Editar Pausa" : "Adicionar Pausa"}</DialogTitle>
      <Formik
        initialValues={pause}
        enableReinitialize={true}
        validationSchema={PauseSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            handleSavePause(values);
            actions.setSubmitting(false);
          }, 400);
        }}
      >
        {({ touched, errors, isSubmitting }) => (
          <Form>
            <DialogContent dividers>
              <Field
                as={TextField}
                label="Nome"
                autoFocus
                name="name"
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary" disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting} variant="contained">
                {isSubmitting ? <CircularProgress size={24} /> : "Salvar"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
export default PauseModal;
